import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="bg-spiritual-900 py-16 md:py-24 relative" data-id="element-271">
      <div className="absolute inset-0 opacity-[0.03]" data-id="element-272">
        <div className="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-spiritual-400 rounded-full blur-3xl" data-id="element-273" />
      </div>

      <div className="max-w-5xl mx-auto px-5 md:px-8 relative z-10" data-id="element-274">
        <div className="text-center mb-12" data-id="element-275">
          <span className="text-spiritual-400 font-body text-sm uppercase tracking-widest mb-4 block" data-id="element-276">
            Testimonios
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-spiritual-100" data-id="element-277">
            Mujeres que ya rompieron{' '}
            <span className="text-gold-gradient" data-id="element-278">el patrón</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-279">
          <div className="bg-spiritual-800/40 border border-spiritual-700/40 rounded-2xl p-6" data-id="element-280">
            <QuoteIcon className="w-8 h-8 text-spiritual-400/30 mb-4" aria-hidden="true" data-id="element-281" />
            <p className="text-spiritual-200 font-body text-sm leading-relaxed mb-6" data-id="element-282">
              "Siempre sentí que no merecía ganar bien. Después del ritual de
              corte, en menos de 3 semanas me llegó una oferta de trabajo con el
              doble de salario. No es magia, es que dejé de bloquearme."
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-spiritual-700/30" data-id="element-283">
              <div className="w-10 h-10 bg-spiritual-700 rounded-full flex items-center justify-center" data-id="element-284">
                <span className="text-spiritual-300 font-heading font-bold text-sm" data-id="element-285">
                  MG
                </span>
              </div>
              <div data-id="element-286">
                <p className="text-spiritual-100 font-body font-bold text-sm" data-id="element-287">
                  María G.
                </p>
                <div className="flex gap-0.5" data-id="element-288">
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-289" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-290" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-291" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-292" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-293" />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-spiritual-800/40 border border-spiritual-700/40 rounded-2xl p-6" data-id="element-294">
            <QuoteIcon className="w-8 h-8 text-spiritual-400/30 mb-4" aria-hidden="true" data-id="element-295" />
            <p className="text-spiritual-200 font-body text-sm leading-relaxed mb-6" data-id="element-296">
              "Descubrí que mi abuela perdió todo en una crisis y desde entonces
              mi familia vive con miedo al dinero. Hacer el genograma fue
              revelador. Por primera vez siento que puedo ahorrar sin ansiedad."
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-spiritual-700/30" data-id="element-297">
              <div className="w-10 h-10 bg-spiritual-700 rounded-full flex items-center justify-center" data-id="element-298">
                <span className="text-spiritual-300 font-heading font-bold text-sm" data-id="element-299">
                  CP
                </span>
              </div>
              <div data-id="element-300">
                <p className="text-spiritual-100 font-body font-bold text-sm" data-id="element-301">
                  Carolina P.
                </p>
                <div className="flex gap-0.5" data-id="element-302">
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-303" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-304" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-305" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-306" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-307" />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-spiritual-800/40 border border-spiritual-700/40 rounded-2xl p-6" data-id="element-308">
            <QuoteIcon className="w-8 h-8 text-spiritual-400/30 mb-4" aria-hidden="true" data-id="element-309" />
            <p className="text-spiritual-200 font-body text-sm leading-relaxed mb-6" data-id="element-310">
              "Soy emprendedora y cada vez que mis ventas subían, algo pasaba y
              volvía a cero. El test de diagnóstico me mostró que tenía un
              contrato de 'no superar a mamá'. Hoy facturo el triple sin culpa."
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-spiritual-700/30" data-id="element-311">
              <div className="w-10 h-10 bg-spiritual-700 rounded-full flex items-center justify-center" data-id="element-312">
                <span className="text-spiritual-300 font-heading font-bold text-sm" data-id="element-313">
                  AL
                </span>
              </div>
              <div data-id="element-314">
                <p className="text-spiritual-100 font-body font-bold text-sm" data-id="element-315">
                  Ana L.
                </p>
                <div className="flex gap-0.5" data-id="element-316">
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-317" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-318" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-319" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-320" />
                  <StarIcon className="w-3.5 h-3.5 fill-spiritual-400 text-spiritual-400" aria-hidden="true" data-id="element-321" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}